var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSupportChatIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.587 7.027c-.533-.227-.76-.887-.44-1.367C7.794 4.7 8.874 4 10.3 4c1.567 0 2.64.713 3.187 1.607.467.766.74 2.2.02 3.266-.8 1.18-1.566 1.54-1.98 2.3-.1.18-.16.327-.2.627a.971.971 0 01-.953.867c-.58 0-1.053-.5-.987-1.08.04-.34.12-.694.307-1.027.513-.927 1.5-1.473 2.073-2.293.607-.86.267-2.467-1.453-2.467-.78 0-1.287.407-1.6.893-.233.38-.72.5-1.127.334zm4.053 8.306c0 .734-.6 1.334-1.333 1.334s-1.333-.6-1.333-1.334c0-.733.6-1.333 1.333-1.333s1.333.6 1.333 1.333z"
  })));
}
export default SvgSupportChatIcon;